// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { GroupsResponse } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/models/groups.response';

export const groupsRequested = createAction('[ADD TO GROUP] Groups Requested', props<{ clientId: number }>());
export const groupsRequestSuccess = createAction('[ADD TO GROUP] Groups Request Success', props<{ groupsResponse: GroupsResponse }>());
export const groupsRequestError = createAction('[ADD TO GROUP] Groups Request Error');

export const addToGroupRequested = createAction('[ADD TO GROUP] Add To Group Requested', props<{
  clientId: number,
  groupId: string,
  selections: number[],
  version: number,
  name: string
}>());
export const addToGroupRequestSuccess = createAction('[ADD TO GROUP] Add To Group Request Success', props<{
  clientId: number,
  groupId: string,
  name: string
}>());
export const addToGroupRequestError = createAction('[ADD TO GROUP] Add To Group Request Error');
